<div id="contact" class="contact-area ptb-100 bg-F7F5F4">
  <div class="container">
    <div class="section-title">
      <h2><span>{{ 'contact.title' | translate }}</span></h2>
    </div>
    <div class="row">
      <div class="col-lg-7 col-md-12">
        <div class="contact-form">
          <form #contactForm="ngForm" (ngSubmit)="submit(contactForm)">
            <div class="row">
              <div class="col-lg-6 col-md-6">
                <div class="form-group mb-3">
                  <label>{{ 'contact.name' | translate }}</label>
                  <input required minlength="3" maxlength="50" ngModel name="name" type="text" #name="ngModel" class="form-control" id="name">
                  @if (name.touched && name.errors) {
                    <div class="alert alert-danger">
                      @if (name.errors.required) {
                        <div>{{ 'contact.nameRequired' | translate }}</div>
                      }
                      @if (name.errors.minlength) {
                        <div>{{ 'contact.nameMin' | translate:{n: name.errors.minlength.requiredLength} }}</div>
                      }
                      @if (name.errors.maxlength) {
                        <div>{{ 'contact.nameMax' | translate }}</div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="form-group mb-3">
                  <label>{{ 'contact.email' | translate }}</label>
                  <input required ngModel name="email" type="email" email #email="ngModel" class="form-control" id="email">

                  @if (email.touched && email.errors) {
                    <div class="alert alert-danger">
                      @if (email.errors.required) {
                        <div>{{ 'contact.emailRequired' | translate }}</div>
                      }
                      @if (email.errors.email) {
                        <div>{{ 'contact.emailInvalid' | translate }}</div>
                      }
                    </div>
                  }

                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class=" mb-3">
                  <label>{{ 'contact.subject' | translate }}</label>
                  <ng-select required
                    [items]="subjectList"
                    bindLabel="name"
                    [(ngModel)]="mysubject"
                    name="subject"
                    #subject="ngModel"
                    id="subject"
                    appendTo="body"
                    [dropdownPosition]="'bottom'">
                  </ng-select>
                  @if (subject.touched && !subject.valid) {
                    <div class="alert alert-danger">{{ 'contact.subjectRequired' | translate }}</div>
                  }
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="form-group mb-3">
                  <label>{{ 'contact.phone' | translate }}</label>
                  <input required ngModel name="number" type="text" #number="ngModel" class="form-control" id="number">
                  @if (number.touched && !number.valid) {
                    <div class="alert alert-danger">{{ 'contact.phoneRequired' | translate }}</div>
                  }
                </div>
              </div>
              <div class="col-lg-12 col-md-12">
                <div class="form-group mb-3">
                  <label>{{ 'contact.message' | translate }}</label>
                  <textarea required ngModel #message="ngModel" name="message" id="message" cols="30" rows="4" class="form-control"></textarea>
                  @if (message.touched && !message.valid) {
                    <div class="alert alert-danger">{{ 'contact.messageRequired' | translate }}</div>
                  }
                </div>
              </div>
              <div class="col-lg-12 col-md-12">
                <button type="submit" class="btn btn-primary" [class.disabled]="!contactForm.valid">{{ 'contact.send' | translate }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-lg-5 col-md-12">
        <div class="contact-info">
          <div class="d-table">
            <div class="d-table-cell">
              <ul>
                <li>
                  <i class="fas fa-map-marker-alt"></i> <span>{{ 'contact.location' | translate }}</span>
                  <p>
                    Torre Norte,  <br>
                    piso 3, Ofci 3-7/3-8, <br>
                    Centro Comercial El Recreo, <br>
                    Calle el Recreo, <br>
                    Caracas, Venezuela
                  </p>

                </li>
                <li><i class="far fa-envelope"></i> <a href="mailto:info@pafar.net"><span>{{ 'contact.email' | translate }}:</span>info&#64;pafar.net</a></li>
                <li hidden><i class="fas fa-phone-alt"></i> <a href="tel:1244122445515"><span>{{ 'contact.phone' | translate }}:</span>(+58)999-9999999</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
